/**
 * Kullanıcının ülkesi — TEK UYGULAMA (Sokak Kedileri / StrayPaw).
 *
 * Backend, şehir listesini, fiyatı ve fotoğraf R2 bucket'ını `X-Country`
 * başlığından öğrenir (veri ikametgahı). Bu dosya o kodu belirler.
 *
 * İKİ YÜZ:
 *   - sokakkedileri.tr (Türkiye): REACT_APP_DEFAULT_COUNTRY tanımsız → "tr".
 *   - straypaw.ai (uluslararası): REACT_APP_DEFAULT_COUNTRY="id" → Endonezya
 *     odaklı açılır; kullanıcı içeriden başka ülke seçebilir.
 *
 * Sıra:
 *   1. Kullanıcının uygulama içi seçimi (localStorage) — her şeyi ezer.
 *   2. Derleme zamanı varsayılanı (REACT_APP_DEFAULT_COUNTRY) — domainin yüzü.
 *   3. Son çare: "tr".
 *
 * TUR-8 (29 Ağu 2026) — CİHAZ DİLİ KATMANI KALDIRILDI. Detay aşağıda,
 * `getCountry` başında.
 */

// Aktif pazarlar. Backend bunların hepsini (ve daha fazlasını) tanır; burada
// yalnızca frontend'in X-Country olarak GÖNDERECEĞİ kodlar. Yeni ülke açılınca
// listeye eklenir (backend CITY_COUNTRIES ile birlikte).
export const SUPPORTED_COUNTRIES = ["tr", "in", "br", "eg", "pl", "es", "id"];

const STORAGE_KEY = "sk_country";

function normalize(code) {
  if (!code || typeof code !== "string") return null;
  const c = code.trim().toLowerCase().slice(0, 2);
  return SUPPORTED_COUNTRIES.includes(c) ? c : null;
}

/**
 * Etkin ülke kodu. Kullanıcı seçimi > domainin derleme varsayılanı > "tr".
 *
 * TUR-8 (29 Ağu 2026) — CİHAZ DİLİ KATMANI NEDEN KALDIRILDI
 * ---------------------------------------------------------
 * Eskiden araya bir katman daha giriyordu: cihazın dili. "ar-EG" → "eg",
 * "es-ES" → "es", "id-ID" → "id".
 *
 * O katman TANIM GEREĞİ yalnızca `REACT_APP_DEFAULT_COUNTRY` tanımsızken
 * çalışabiliyordu — çünkü domain varsayılanı ondan önce geliyordu. Ve o
 * değişken tanımsız olan TEK yer Türkiye yüzüydü (`frontend/.env`, Cloudflare
 * `sokakkedileri` projesi). straypaw.ai'de "id" tanımlı olduğu için orada bu
 * katman hiç devreye girmiyordu.
 *
 * Yani katman, YALNIZCA yanlış cevap verebildiği yerde çalışıyordu. Türkiye'de
 * telefonu Arapça olan bir kullanıcı "eg" alıyor, Sokak Kedileri uygulamasında
 * KÖPEK SEÇİCİSİNİ ve StrayPaw markasını görüyordu (TUR-4/TUR-7 kapılarının
 * hepsi `getCountry() !== "tr"` üzerine kurulu). Türkiye'de Arapça, Lehçe,
 * İspanyolca telefon nadir değil.
 *
 * Çözüm neden `.env`'e satır eklemek DEĞİL: TEK-5'in dersi — bir değişikliğin
 * güvenli olması yeni bir yapılandırmanın var olmasına bağlıysa, o değişiklik
 * güvenli değildir. Katman kalkınca yapılandırma eksikse kod en KISITLI
 * cevaba düşüyor ("tr"), en gevşek olana değil. `.env`'e satır eklemek
 * yine de iyi olur ama artık güvenlik ona bağlı değil.
 *
 * Kaybedilen davranış: straypaw.ai'ye Brezilyalı tarayıcıyla giren biri
 * otomatik "br" almıyor, "id" alıyor. Zaten öyleydi — domain varsayılanı
 * cihaz dilinden önce geliyordu. Ülke seçimi 2.8.0'daki açılış ekranından
 * yapılacak; tahmin değil, seçim.
 */
/**
 * TEK-ULKE (2 Eyl 2026) — derleme zamanı ülke kilidi.
 *
 * NEDEN VAR: Play'deki Sokak Kedileri, K-33 kararına göre TÜRKİYE uygulaması
 * olarak kalıyor (StrayPaw Android'de ayrı bir kayıt). Ama 2.8.0'daki ülke
 * seçim ekranı native'de alan adına bakamadığı için orada da açılıyor ve
 * Türk kullanıcıya "ülkeni seç" diye soruyor — hatta Endonezya'yı seçip
 * StrayPaw veritabanına düşebiliyor. iOS'ta bu KASITLI (tek uygulama, 4.3a);
 * Android'de kararla çelişiyor.
 *
 * Bu değişken verildiğinde: ülke ona sabitlenir, kullanıcı seçimi ve
 * REACT_APP_DEFAULT_COUNTRY dahil her şeyi ezer, ülke ekranı hiç açılmaz.
 *
 * TEK-5'in dersi korunuyor: değişken YOKSA hiçbir şey değişmez — bugünkü
 * davranış (sor) sürer. Güvenlik yeni bir yapılandırmanın VAR olmasına
 * değil, YOK olmasına dayanıyor.
 *
 * Kullanım: REACT_APP_TEK_ULKE=tr npm run build  →  yalnızca Android sokak
 * flavor'ı için. iOS ve straypaw.ai bu değişken OLMADAN derlenir.
 */
export const TEK_ULKE = (() => {
  const v = String(process.env.REACT_APP_TEK_ULKE || "").trim().toLowerCase().slice(0, 2);
  return SUPPORTED_COUNTRIES.includes(v) ? v : null;
})();

export function getCountry() {
  // Kilit varsa hiçbir şeye bakma — kullanıcı seçimi bile bunu ezemez.
  if (TEK_ULKE) return TEK_ULKE;
  let stored = null;
  try {
    stored = localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    /* gizli sekme / depolama kapalı */
  }
  return (
    normalize(stored) ||
    normalize(process.env.REACT_APP_DEFAULT_COUNTRY) ||
    "tr"
  );
}

// Ülkenin varsayılan harita merkezi (başkent/ana şehir) [lat, lng]. Harita bu
// koordinata açılır; kullanıcının GPS'i veya verisi varsa oraya kayar. Yeni bir
// ülke açılınca buraya TEK SATIR koordinat eklemek yeterli — 30 ülke için ayrı
// "harita işi" yok, hepsi bu tablodan beslenir.
export const DEFAULT_CENTER_BY_COUNTRY = {
  tr: [41.0082, 28.9784], // İstanbul
  id: [-6.2088, 106.8456], // Jakarta
  in: [19.076, 72.8777], // Mumbai
  br: [-23.5505, -46.6333], // São Paulo
  eg: [30.0444, 31.2357], // Kahire
  pl: [52.2297, 21.0122], // Varşova
  es: [40.4168, -3.7038], // Madrid
};

/** Aktif ülkenin varsayılan harita merkezi. Bilinmiyorsa Türkiye (İstanbul). */
export function getDefaultCenter() {
  return DEFAULT_CENTER_BY_COUNTRY[getCountry()] || DEFAULT_CENTER_BY_COUNTRY.tr;
}

/** Kullanıcı ülkesini elle seçtiğinde çağrılır. */
export function setCountry(code) {
  const c = normalize(code);
  if (!c) return false;
  try {
    localStorage.setItem(STORAGE_KEY, c);
  } catch (e) {
    return false;
  }
  return true;
}

/**
 * GÜVENLIK-1 (30 Ağu 2026) — güvenlik rehberi yalnızca Türkiye'de açık.
 *
 * NEDEN
 * -----
 * `CatSafety` sayfası ısırık/tırmık sonrası ne yapılacağını anlatıyor ve
 * içeriği baştan sona TÜRKİYE'ye özel: acil numaralar (112 / 184 / 153)
 * `CatSafety.jsx`'te SABİT yazılı, metinlerde "Aile Sağlığı Merkezi",
 * "sağlık ocağı", "acil servis", "Batticon", "In Turkey", "in Istanbul"
 * geçiyor, kuduz profilaksisinin ücretsiz olduğu bilgisi Türkiye devlet
 * hastanelerine dayanıyor.
 *
 * Bu, `tagline`'ın kedi demesiyle aynı sınıfta bir hata DEĞİL. Endonezya'da
 * kedi ısıran birine 184'ü aramasını söylemek yanlış bilgi vermek demek —
 * üstelik kendi dilinde, yani daha inandırıcı. Yanlış acil numara, hiç
 * numara vermemekten kötüdür.
 *
 * Bu yüzden çeviri de yapılmadı: `safety.*` (57 anahtar) pt-br ve es
 * sözlüklerinde BİLEREK yok.
 *
 * KALICI ÇÖZÜM DEĞİL
 * ------------------
 * GÜVENLIK-2 (2.9.0): numaralar ve sağlık sistemi atıfları ülke
 * yapılandırmasından gelecek. Her ülkenin acil numarası TEK TEK
 * doğrulandıktan sonra o ülkede açılır — önce değil.
 *
 * Kapı hem rotada hem bağlantılarda: yalnız bağlantıyı gizlemek adresi
 * erişilebilir bırakırdı ve paylaşılmış bir bağlantı kapıyı deler.
 */
export function guvenlikSayfasiAcikMi() {
  try {
    return getCountry() === "tr";
  } catch {
    // Ülke okunamıyorsa GÖSTERME. Yanlış tarafa düşmek pahalı: bilinmeyen
    // bir ülkede Türkiye numaralarını göstermektense sayfayı hiç açmamak
    // iyidir.
    return false;
  }
}
